/**
 * Get the customer facing manufacturer name from the brand string
 *
 * The returned name must match the manufacturer as it is stored against the stock,
 * because it is used as a search filter value as well as for display.
 * @param {string} brand
*/
export default function(brand = '') {
    switch (brand) {
        case 'abarth':
        case 'audi':
        case 'citroen':
        case 'cupra':
        case 'dacia':
        case 'fiat':
        case 'ford':
        case 'honda':
        case 'hyundai':
        case 'jaguar':
        case 'jeep':
        case 'kia':
        case 'leapmotor':
        case 'lexus':
        case 'maxus':
        case 'mazda':
        case 'mini':
        case 'mitsubishi':
        case 'nissan':
        case 'peugeot':
        case 'renault':
        case 'seat':
        case 'skoda':
        case 'smart':
        case 'suzuki':
        case 'toyota':
        case 'vauxhall':
        case 'volkswagen':
        case 'volvo':
            return brand.charAt(0).toUpperCase() + brand.slice(1, brand.length);

        case 'bmw':
        case 'kgm':
        case 'mg':
            return brand.toUpperCase();

        case 'alfa-romeo':
            return 'Alfa Romeo';

        case 'land-rover':
            return 'Land Rover';

        case 'mercedes-benz':
            return 'Mercedes-Benz';

        case 'ds':
        case 'ds automobiles':
        case 'ds-automobiles':
            return 'DS Automobiles';

        default:
            return 'Stellantis &You UK';
    }
}
